var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"cards-main__link blue-btn",attrs:{"href":_vm.finalUrl}},[_vm._v(_vm._s(_vm._f("trans")(_vm.finalText)))])
}
var staticRenderFns = []

export { render, staticRenderFns }